import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportedCountriesComponent } from './country/supported-countries.component';
import { SupportedCountriesV2Component } from './country-v2/supported-countries-v2.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
  ],
  declarations: [SupportedCountriesComponent, SupportedCountriesV2Component],
  exports: [SupportedCountriesComponent, SupportedCountriesV2Component],
})
export class RestrictionsModule {}
